module.exports = __webpack_public_path__ + "static/media/seminary2.aac96781.jpg";